(() => {
  const nav = document.querySelector('[data-cb-page]');
  if (!nav) return;
  const key = 'cb-catalog-return';
  const save = () => {
    try {
      sessionStorage.setItem(key, JSON.stringify({ url: location.pathname + location.search, title: nav.querySelector('[data-cb-collection-title]')?.textContent.trim() }));
    } catch {}
  };
  if (nav.dataset.cbPage === 'collection') {
    save();
    document.addEventListener('click', event => {
      if (event.target.closest('a[href*="/products/"]')) save();
    }, true);
    return;
  }
  try {
    const previous = JSON.parse(sessionStorage.getItem(key));
    if (!previous || !document.referrer) return;
    const referrer = new URL(document.referrer);
    const url = new URL(previous.url, location.origin);
    if (url.origin !== location.origin || referrer.origin !== location.origin || !url.pathname.startsWith('/collections/') || referrer.pathname !== url.pathname) return;
    const back = nav.querySelector('[data-cb-back]');
    if (back) back.href = url.pathname + url.search;
    const parent = nav.querySelector('[data-cb-parent]');
    if (parent && previous.title) {
      parent.href = url.pathname;
      parent.textContent = previous.title;
    }
  } catch {}
})();
